import { render, staticRenderFns } from "./add_devicetype.vue?vue&type=template&id=161b5c2e&scoped=true"
import script from "./add_devicetype.vue?vue&type=script&lang=js"
export * from "./add_devicetype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161b5c2e",
  null
  
)

export default component.exports